/**
 * Document type codes whose primary content is stored in the native / org-DB stack,
 * not in MediaWiki page bodies. Used to skip wiki-only repair flows (e.g. categorylinks).
 *
 * Keep in sync with `server/constants/nativeDocTypes.js`.
 */
export const NATIVE_DOC_TYPES = ['PA', 'Part Alert', 'TL', 'Tool List'] as const;

export type NativeDocTypeCode = (typeof NATIVE_DOC_TYPES)[number];

export function isNativeDocType(docType: string | undefined | null): boolean {
  if (docType == null || docType === '') return false;
  return (NATIVE_DOC_TYPES as readonly string[]).includes(String(docType));
}
